import * as Yup from 'yup'
import { Formik } from 'formik'

import {
  Grid,
  Card,
  Container,
  CardContent,
  TextField,
  Button,
  InputLabel,
  Checkbox
} from '@mui/material'
import { ActionButton } from '../../../utils/ui_utils'
import SubBusinessDailog from './SubBusinessDailog'
import { useEffect, useState } from 'react'
import { getBusinessDetails } from '../../../components/tsComponents/AuthGuard'
import { getUserType } from '../../../components/AuthGuard'

function EditOutlet({ onSubmit, initialValue, okText }) {
  const [openSubBusinessDialog, setOpenSubBusinessDialog] = useState(false)
  const [selfBusiness, setSelfBusiness] = useState(false)
  const businessDetails = getBusinessDetails()
  if (initialValue == undefined)
    initialValue = {
      name: '',
      gstn: '',
      contact_number: '',
      fax: '',
      address: '',
      city: '',
      pincode: '',
      state: '',
      country: '',
      address: ''
    }

  useEffect(() => {
    if (businessDetails?.name == initialValue.sub_business_name) {
      setSelfBusiness(true)
    }
  }, [initialValue])

  const handleSubmit1 = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting }
  ) => {
    onSubmit(values)
  }

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required('Required')
      .min(2, 'Name must be at least 2 characters')
      .max(30, 'Name must be at most 30 characters'),
    contact_number: Yup.string()
      .min(10, 'Min 10 digits')
      .max(10, 'Max 10 digits')
      .required('Required'),
    city: Yup.string().required('Required'),
    address: Yup.string().required('Required'),
    pincode: Yup.string().required('Required'),
    state: Yup.string().required('Required'),
    country: Yup.string().required('Required'),
    sub_business_name: Yup.string()
      .required('Required')
      .min(2, 'Min 2 characters')
      .max(30, 'Max 30 characters')
  })
  const userType = getUserType()
  return (
    <>
      <Container sx={{ marginBottom: 5 }}>
        <Formik
          initialValues={initialValue}
          validationSchema={validationSchema}
          onSubmit={handleSubmit1}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
            status,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardContent>
                  <Grid container spacing={6}>
                    <Grid item md={6}>
                      <TextField
                        sx={{ fontWeight: 'bold' }}
                        size="small"
                        name="name"
                        label="Name"
                        value={values.name}
                        error={Boolean(touched.name && errors.name)}
                        fullWidth
                        helperText={touched.name && errors.name}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="contact_number"
                        label="Contact Number"
                        value={values.contact_number}
                        error={Boolean(
                          touched.contact_number && errors.contact_number
                        )}
                        fullWidth
                        helperText={
                          touched.contact_number && errors.contact_number
                        }
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={6} alignItems={'center'}>
                    <Grid item md={6}>
                      <TextField
                        sx={{ fontWeight: 'bold' }}
                        size="small"
                        name="sub_business_name"
                        label="Sub Business"
                        disabled={selfBusiness||userType !== 'Owner'}
                        value={values.sub_business_name}
                        error={Boolean(
                          touched.sub_business_name && errors.sub_business_name
                        )}
                        fullWidth
                        helperText={
                          touched.sub_business_name && errors.sub_business_name
                        }
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                        onFocus={(e) => e.target.select()}
                        InputProps={{
                          endAdornment: (
                            <Grid container justifyContent="flex-end">
                              <Grid item>
                                <Button
                                  title="Select Sub Business"
                                  disabled={ selfBusiness||userType !== 'Owner'}
                                  size="medium"
                                  onClick={() => {
                                    setOpenSubBusinessDialog(true)
                                  }}
                                >
                                  Select
                                </Button>
                                <SubBusinessDailog
                                  open={openSubBusinessDialog}
                                  onClose={() =>
                                    setOpenSubBusinessDialog(false)
                                  }
                                  onSubmit={(subBusinessName) => {
                                    setFieldValue(
                                      'sub_business_name',
                                      subBusinessName
                                    )
                                    setOpenSubBusinessDialog(false)
                                  }}
                                />
                              </Grid>
                            </Grid>
                          )
                        }}
                      />
                    </Grid>
                    <Grid item md={4}>
                      <Grid container alignItems={'center'}>
                        <Grid item>
                          <InputLabel>Self Business</InputLabel>
                        </Grid>
                        <Grid item>
                          <Checkbox
                            title="Self Business"
                            disabled={userType !== 'Owner'}
                            checked={selfBusiness}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setFieldValue(
                                  'sub_business_name',
                                  businessDetails?.name
                                )
                                setFieldValue(
                                  'sub_business_name',
                                  businessDetails?.name ?? ''
                                )
                                setFieldValue(
                                  'gstn',
                                  businessDetails?.gstn ?? ''
                                )
                                setFieldValue(
                                  'contact_number',
                                  businessDetails?.telephone ?? ''
                                )
                                setFieldValue('fax', businessDetails?.fax ?? '')
                                setFieldValue(
                                  'address',
                                  businessDetails?.address ?? ''
                                )
                                setFieldValue(
                                  'city',
                                  businessDetails?.city ?? ''
                                )
                                setFieldValue(
                                  'pincode',
                                  businessDetails?.pin ?? ''
                                )
                                setFieldValue(
                                  'state',
                                  businessDetails?.state ?? ''
                                )
                                setFieldValue(
                                  'country',
                                  businessDetails?.country ?? ''
                                )
                              }
                              setSelfBusiness(e.target.checked)
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={6}>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="gstn"
                        label="GSTN"
                        value={values.gstn}
                        error={Boolean(touched.gstn && errors.gstn)}
                        fullWidth
                        helperText={touched.gstn && errors.gstn}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="fax"
                        label="Fax"
                        value={values.fax}
                        error={Boolean(touched.fax && errors.fax)}
                        fullWidth
                        helperText={touched.fax && errors.fax}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={6}>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="pincode"
                        label="PinCode"
                        value={values.pincode}
                        error={Boolean(touched.pincode && errors.pincode)}
                        fullWidth
                        helperText={touched.pincode && errors.pincode}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="city"
                        label="City"
                        value={values.city}
                        error={Boolean(touched.city && errors.city)}
                        fullWidth
                        helperText={touched.city && errors.city}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={6}>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="state"
                        label="State"
                        value={values.state}
                        error={Boolean(touched.state && errors.state)}
                        fullWidth
                        helperText={touched.state && errors.state}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="country"
                        label="Country"
                        value={values.country}
                        error={Boolean(touched.country && errors.country)}
                        fullWidth
                        helperText={touched.country && errors.country}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={6}>
                    <Grid item md={12}>
                      <TextField
                        size="small"
                        name="address"
                        label="Address"
                        value={values.address}
                        error={Boolean(touched.address && errors.address)}
                        fullWidth
                        helperText={touched.address && errors.address}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        multiline
                        my={2}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              {userType === 'Owner' && (
                <Grid container justifyContent="flex-end">
                  <Grid item>
                    <ActionButton
                      variant="outlined"
                      size="medium"
                      type="submit"
                      mt={8}
                    >
                      {okText}
                    </ActionButton>
                  </Grid>
                </Grid>
              )}
            </form>
          )}
        </Formik>
      </Container>
    </>
  )
}

export default EditOutlet
